<template>
  <footer class="pt-16 bg-[#FFF]">
    <div class="wrapper max-w-[1200px] p-8 mx-auto w-full">
      <div class="flex flex-col gap-8 md:gap-16">
        <div class="flex flex-col md:flex-row justify-between gap-4">
          <div class="flex flex-col gap-y-2">
            <h4 class="font-semibold">{{ t('main.footer.general') }}</h4>
            <ul class="flex flex-col text-lighter">
              <li>
                <RouterLink :to="{name: 'home.index'}">
                  {{ t('main.menu.home.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'pricing.index'}">
                  {{ t('main.menu.prices.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'info.support'}" class="submenu-item">
                  {{ t('main.menu.info.submenu.support.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'info.support'}" class="submenu-item">
                  {{ t('main.menu.info.submenu.contact.text') }}
                </RouterLink>
              </li>
            </ul>
          </div>

          <div class="flex flex-col gap-y-2">
            <h4 class="font-semibold">{{ t('main.footer.products') }}</h4>
            <ul class="flex flex-col text-lighter">
              <li>
                <RouterLink :to="{name: 'products.webshop'}" class="submenu-item">
                  {{ t('main.menu.products.submenu.webshop.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'products.manager'}" class="submenu-item">
                  {{ t('main.menu.products.submenu.manager.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'products.page'}" class="submenu-item">
                  {{ t('main.menu.products.submenu.page.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'products.pos'}" class="submenu-item">
                  {{ t('main.menu.products.submenu.pos.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'products.qr'}" class="submenu-item">
                  {{ t('main.menu.products.submenu.qr.text') }}
                </RouterLink>
              </li>
            </ul>
          </div>

          <div class="flex flex-col gap-y-2">
            <h4 class="font-semibold">{{ t('main.footer.cases') }}</h4>
            <ul class="flex flex-col text-lighter">
              <li>
                <RouterLink :to="{name: 'cases.cafetaria'}" class="submenu-item">
                  {{ t('main.menu.cases.submenu.cafetaria.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'cases.grillroom'}" class="submenu-item">
                  {{ t('main.menu.cases.submenu.grillroom.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'cases.sushi'}" class="submenu-item">
                  {{ t('main.menu.cases.submenu.sushi.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'cases.italian'}" class="submenu-item">
                  {{ t('main.menu.cases.submenu.italian.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'cases.lunchroom'}" class="submenu-item">
                  {{ t('main.menu.cases.submenu.lunchroom.text') }}
                </RouterLink>
              </li>
            </ul>
          </div>

          <div class="flex flex-col gap-y-2">
            <h4 class="font-semibold">{{ t('main.footer.info') }}</h4>
            <ul class="flex flex-col text-lighter">
              <li>
                <a href="https://bistroo-merchants.trengohelp.com/nl" target="_blank" class="submenu-item">
                  {{ t('main.menu.info.submenu.helpcenter.text') }}
                </a>
              </li>
              <li>
                <RouterLink :to="{name: 'info.faq'}" class="submenu-item">
                  {{ t('main.menu.info.submenu.faq.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'info.integrations'}" class="submenu-item">
                  {{ t('main.menu.info.submenu.integrations.text') }}
                </RouterLink>
              </li>
              <li>
                <RouterLink :to="{name: 'info.downloads'}" class="submenu-item">
                  {{ t('main.menu.info.submenu.downloads.text') }}
                </RouterLink>
              </li>
              
            </ul>
          </div>
        </div>

        <div class="w-full flex justify-between">
          <img class="max-h-8" src="/images/logo.svg" alt="Bistroo">
          <div class="flex items-center gap-x-4">
            <a class="text-xl text-lighter" href="#">
              <i title="LinkedIn" aria-label="LinkedIn" class="bi bi-linkedin"></i>
            </a>
            <a class="text-xl text-lighter" href="#">
              <i title="Twitter / X" aria-label="Twitter / X" class="bi bi-twitter-x"></i>
            </a>
            <a class="text-xl text-lighter" href="#">
              <i title="YouTube" aria-label="YouTube" class="bi bi-youtube"></i>
            </a>
          </div>
        </div>

        <div class="w-full flex flex-col md:flex-row md:justify-between gap-4">
          <div class="flex items-center gap-x-2 text-lighter text-sm">
            <i class="bi bi-c-circle"></i>
            <span>{{ year }}</span>
            <span>Bistroo - All rights reserved</span>
          </div>
          <div class="flex flex-col md:flex-row md:items-center gap-4 text-lighter text-sm">
            <a href="#">Terms of Service</a>
            <a href="#">Privacy Policy</a>
            <a href="#">Security</a>
            <a href="#">Imprint</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { type RouteLocationRaw, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const {t} = useI18n()
const year = (new Date()).getFullYear()
</script>

<style scoped>

</style>